// extracted by mini-css-extract-plugin
export default {"employeeBlock":"EmployeeBlock_employeeBlock__-bG-f","employeePhone":"EmployeeBlock_employeePhone__0yGaE","employeeDuration":"EmployeeBlock_employeeDuration__wQk3y"};